module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reporte-balance-kr/detalles-balance-kr-modal/detalles-balance-kr-modal.component.scss
// module id = ./src/app/components/reporte-balance-kr/detalles-balance-kr-modal/detalles-balance-kr-modal.component.scss
// module chunks = main